/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {ProgressIndicatorDefaultExample, ProgressIndicatorCircularExample, ProgressIndicatorCircularLabelHorizontalExample, ProgressIndicatorCircularLabelVerticalExample, ProgressIndicatorCircularLabelInsideExample, ProgressIndicatorCircularPrimaryExample, ProgressIndicatorCircularRandomExample, ProgressIndicatorCircularRandomTransitionExample, ProgressIndicatorCircularRandomOnCompleteExample, ProgressIndicatorCircularDialogExample, ProgressIndicatorLinearDefaultExample, ProgressIndicatorLinearSmallExample, ProgressIndicatorLinearLabelHorizontalExample, ProgressIndicatorLinearLabelVerticalExample, ProgressIndicatorLinearLargeExample, ProgressIndicatorLinearRandomExample, ProgressIndicatorLinearRandomTransitionExample, ProgressIndicatorLinearRandomOnCompleteExample, ProgressIndicatorLinearDialogExample, ProgressIndicatorCountdownExample, ProgressIndicatorCustomCountdown, ProgressIndicatorCustomHorizontal, ProgressIndicatorCustomizationExample} from 'Docs/uilib/components/progress-indicator/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    code: "code"
  }, _provideComponents(), props.components), {VisibleWhenVisualTest} = _components;
  if (!VisibleWhenVisualTest) _missingMdxReference("VisibleWhenVisualTest", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Default ProgressIndicator is Circular"
    }), "\n", _jsx(ProgressIndicatorDefaultExample, {}), "\n", _jsx(_components.h3, {
      children: "Default Circular ProgressIndicator"
    }), "\n", _jsx(ProgressIndicatorCircularExample, {}), "\n", _jsx(_components.h3, {
      children: "Circular ProgressIndicator with a label in a horizontal direction"
    }), "\n", _jsx(ProgressIndicatorCircularLabelHorizontalExample, {}), "\n", _jsx(_components.h3, {
      children: "Circular ProgressIndicator with a label in a vertical direction"
    }), "\n", _jsx(ProgressIndicatorCircularLabelVerticalExample, {}), "\n", _jsx(_components.h3, {
      children: "Circular ProgressIndicator with a label inside"
    }), "\n", _jsx(_components.p, {
      children: "Inside labels must be carefully sized, and are generally meant for just an icon or a number."
    }), "\n", _jsx(ProgressIndicatorCircularLabelInsideExample, {}), "\n", _jsx(_components.h3, {
      children: "Shows a large Circular ProgressIndicator with a static 50% in progress"
    }), "\n", _jsx(ProgressIndicatorCircularPrimaryExample, {}), "\n", _jsx(_components.h3, {
      children: "Circular ProgressIndicator with random value"
    }), "\n", _jsx(ProgressIndicatorCircularRandomExample, {}), "\n", _jsx(_components.h3, {
      children: "Circular ProgressIndicator with random progress value to show the transition"
    }), "\n", _jsx(ProgressIndicatorCircularRandomTransitionExample, {}), "\n", _jsxs(_components.h3, {
      children: ["Circular ProgressIndicator with random ", _jsx(_components.code, {
        children: "on_complete"
      }), " callback"]
    }), "\n", _jsx(ProgressIndicatorCircularRandomOnCompleteExample, {}), "\n", _jsx(_components.h3, {
      children: "Circular ProgressIndicator inside a Dialog"
    }), "\n", _jsx(ProgressIndicatorCircularDialogExample, {}), "\n", _jsx(_components.h3, {
      children: "Default Linear ProgressIndicator"
    }), "\n", _jsx(ProgressIndicatorLinearDefaultExample, {}), "\n", _jsx(_components.h3, {
      children: "Small Linear ProgressIndicator"
    }), "\n", _jsx(ProgressIndicatorLinearSmallExample, {}), "\n", _jsx(_components.h3, {
      children: "Linear ProgressIndicator with a label in a horizontal direction"
    }), "\n", _jsx(ProgressIndicatorLinearLabelHorizontalExample, {}), "\n", _jsx(_components.h3, {
      children: "Linear ProgressIndicator with a label in a vertical direction"
    }), "\n", _jsx(ProgressIndicatorLinearLabelVerticalExample, {}), "\n", _jsx(_components.h3, {
      children: "Shows a large Linear ProgressIndicator with a static 50% in progress"
    }), "\n", _jsx(ProgressIndicatorLinearLargeExample, {}), "\n", _jsx(_components.h3, {
      children: "Linear ProgressIndicator with random value"
    }), "\n", _jsx(ProgressIndicatorLinearRandomExample, {}), "\n", _jsx(_components.h3, {
      children: "Linear ProgressIndicator with random progress value to show the transition"
    }), "\n", _jsx(ProgressIndicatorLinearRandomTransitionExample, {}), "\n", _jsxs(_components.h3, {
      children: ["Linear ProgressIndicator with random ", _jsx(_components.code, {
        children: "on_complete"
      }), " callback"]
    }), "\n", _jsx(ProgressIndicatorLinearRandomOnCompleteExample, {}), "\n", _jsx(_components.h3, {
      children: "Linear ProgressIndicator inside a Dialog"
    }), "\n", _jsx(ProgressIndicatorLinearDialogExample, {}), "\n", _jsx(_components.h3, {
      children: "Countdown indicator"
    }), "\n", _jsx(ProgressIndicatorCountdownExample, {}), "\n", _jsx(_components.h3, {
      children: "Style customization"
    }), "\n", _jsxs(_components.p, {
      children: ["The sizes and colors can be customized with the properties ", _jsx(_components.code, {
        children: "size"
      }), ", ", _jsx(_components.code, {
        children: "customColors"
      }), ", and ", _jsx(_components.code, {
        children: "customCircleWidth"
      }), " if needed. The types ", _jsx(_components.code, {
        children: "circular"
      }), " and ", _jsx(_components.code, {
        children: "countdown"
      }), " has a few more options than ", _jsx(_components.code, {
        children: "linear"
      }), "."]
    }), "\n", _jsx(ProgressIndicatorCustomCountdown, {}), "\n", _jsx(ProgressIndicatorCustomHorizontal, {}), "\n", _jsx(VisibleWhenVisualTest, {
      children: _jsx(ProgressIndicatorCustomizationExample, {})
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
